import Api from "./Api";
import { showToast } from "../helper/Toast";

const BASE_URL = "auth";

const login = async (authData) => {
  if (authData.name && authData.password) {
    try {
      let response = await Api.post(`${BASE_URL}/login`, authData);
      if (response) {
        localStorage.setItem("token", response.accessToken);
        return response;
      } else {
        return null;
      }
    } catch (error) {
      showToast("Server Error", "ERROR");
      console.error(error);
    }
  }
};

const authService = {
  login,
};

export default authService;
